<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />

    <!-- Person details & top mention -->
    <div class="row">
      <div class="col-lg-6 col-sm-6">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-4">
                <h5>{{ $t("twitter.basic-info") }}</h5>
              </div>
              <div class="col-sm-8 text-right text-secondary">
                <!-- <router-link
                  :to="'/report-twitter/' + id"
                  target="_blank"
                  class="mr-1"
                >
                  <b-button class="btn btn-sm text-secondary" variant="light"
                    ><i class="mdi mdi-badge-account-horizontal-outline"></i>
                    {{ $t("twitter.report") }} Tiktok</b-button
                  >
                </router-link> -->
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="searchUserinfo(basicInfo.account)"
                >
                  <span v-if="loading_update"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                    Loading..</span
                  >
                  <span v-if="!loading_update"
                    ><i class="bx bx-history"></i>
                    {{ $t("twitter.update") }}
                  </span></b-button
                >
              </div>
            </div>
            <div class="mb-3 mt-4">
              <div class="media">
                <img
                  :src="
                    basicInfo.picture != ''
                      ? 'https://m-p16.akamaized.net/obj/' + basicInfo.picture
                      : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'
                  "
                  class="mr-3 rounded-circle avatar-md"
                  alt="user-pic"
                />
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("tiktok.upload") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.video_count }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("tiktok.following") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.following }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("tiktok.followers") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.followers }}</h6>
                </div>

                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("tiktok.likes") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.likes }}</h6>
                </div>
              </div>
            </div>
            <div>
              <a
                :href="'https://www.tiktok.com/@' + basicInfo.account"
                target="_blank"
                ><p class="text-primary">
                  {{ basicInfo.full_name }}
                  <span v-if="basicInfo.is_verified == 1"
                    ><i
                      class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"
                    ></i
                  ></span>
                  &nbsp;
                  <span
                    v-if="basicInfo.is_private == 1"
                    class="text-secondary align-items-center"
                  >
                    <i
                      class="text-dark mdi mdi-shield-lock-outline mdi-24px"
                    ></i>
                    {{ $t("twitter.account-private") }}
                  </span>
                </p></a
              >
              <a
                :href="'https://www.tiktok.com/@' + basicInfo.account"
                target="_blank"
                ><p class="text-secondary">@{{ basicInfo.account }}</p>
              </a>
              <p>Bio</p>
              <p>{{ basicInfo.bio }}</p>
              <p>
                <i class="bx bx-calendar"> </i> {{ $t("twitter.updated") }}:
                {{ formatDateRefresh(basicInfo.updated_at) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-sm-6">
        <div class="card" style="height: 570px">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-6">
                <h5>-</h5>
              </div>
              <div class="col-sm-6 text-right">
                <!-- <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="created_at_topmention"
                >
                  {{ $t("twitter.update") }} :
                  {{ formatDateRefresh(created_at_topmention) }}</span
                > -->
                <span>-</span>
              </div>
            </div>
            <div class="row pt-4">
              <div class="col-sm-12 p-5 mt-5" v-if="loadingtopmention">
                <div class="text-center loading">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
              <div
                class="col-sm-12 p-5 mt-5"
                v-if="!loadingtopmention && !topMention[0]"
              >
                <div class="text-center loading">
                  <!-- {{ $t("all.dnf") }} -->
                  -
                </div>
              </div>
              <div
                class="table-responsive mb-0"
                v-if="!loadingtopmention && topMention[0]"
              >
                <b-table
                  :items="topMention"
                  :fields="fieldsTopMention"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                >
                  <template #cell(user_mention)="row">
                    <a
                      :href="'https://twitter.com/' + row.item.user_mention"
                      target="_blank"
                      >{{ row.item.user_mention }}</a
                    >
                  </template>
                  <template #cell(percentage)="row">
                    {{ toFixed(row.item.percentage) }} %
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Timeline tweets  -->
    <div class="row mt-4 mb-4">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="pt-4 px-4">
                {{ $t("tiktok.last_post") }}
              </h5>
            </div>
            <div class="col-sm-6 text-right pt-4 px-4">
              <span class="text-secondary btn btn-sm btn-light mr-1"
                >{{ $t("twitter.updated") }}
                {{ formatDateRefresh(created_at_timeline) }}</span
              >
              <b-button
                class="btn btn-sm"
                variant="success"
                @click="getTimelineInstaRapid"
              >
                <span v-if="loadingupdate"
                  ><b-spinner
                    label="Loading ..."
                    small
                    class="p-0 mb-1"
                    style="width: 0.6rem; height: 0.6rem"
                  ></b-spinner
                ></span>
                <span v-if="!loadingupdate"><i class="bx bx-history"></i></span
              ></b-button>
            </div>
          </div>

          <!-- <div class="col-sm-12">
            <div id="map" class="mt-4 px-2">
              <GmapMap
                ref="mymap"
                :center="center"
                :zoom="zoom"
                style="height: 50vh"
              >
                <GmapMarker
                  v-for="(m, index) in location_coor"
                  :key="index"
                  :position="{
                    lat: parseFloat(m.lat),
                    lng: parseFloat(m.long),
                  }"
                  :icon="{
                    url: 'https://img.icons8.com/fluency/35/000000/twitter.png',
                    width: 35,
                    height: 35,
                    anchor: { x: 5, y: 25 },
                  }"
                  @click="openMarker(index)"
                >
                  <gmap-info-window
                    :opened="openedMarkerID === index"
                    @closeclick="openMarker(null)"
                  >
                    <div class="p-2">
                      <h5>Date : {{ formatDate(m.content.date) }}</h5>
                      <p class="mt-2" style="width: 200px">
                        {{ m.content.caption }}
                      </p>
                    </div>
                  </gmap-info-window>
                </GmapMarker>
              </GmapMap>
            </div>
          </div> -->

          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingtimeline">
            <div class="text-center loading mb-5">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingtimeline && !tableData[0]"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="card-body" v-if="!loadingtimeline && tableData[0]">
            <div class="row mt-0 mb-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("all.entries") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fieldsTimeline"
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(create_time)="row">
                  <span class="text-secondary"
                    >{{ formatDay(row.item.create_time) }},</span
                  >
                  <br />
                  <span class="text-secondary">{{ row.item.create_time }}</span>
                </template>
                <template #cell(cover)="row">
                  <span class="text-secondary"
                    ><img
                      :src="'https://m-p16.akamaized.net/obj/' + row.item.cover"
                      alt=""
                      height="100"
                      width="80"
                    />
                  </span>
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="row.item.share_url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button
                      class="mr-2 btn-sm"
                      variant="primary"
                      title="Show"
                    >
                      <i class="bx bx-show-alt"></i> </b-button
                  ></a>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Followers Following top 5 -->
    <div class="row mt-4 mb-4">
      <div class="col-lg-6 col-sm-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <h5>Last 20 {{ $t("instagram.following") }}</h5>
              </div>
              <div class="col-sm-8 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="following_created_at"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(following_created_at) }}</span
                >
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="getFollowingIGRapid"
                >
                  <span v-if="loadingfollowing"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                  </span>
                  <span v-if="!loadingfollowing"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingfollowing">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingfollowing && !tableDataFollowing[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0 mt-3"
              v-if="!loadingfollowing && tableDataFollowing[0]"
            >
              <b-table
                :items="tableDataFollowing"
                :fields="fieldsFollowing"
                bordered
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filterFollowing"
              >
                <template #cell(date_time)="row">
                  <span class="text-secondary">{{
                    formatDate(row.item.taken_at)
                  }}</span>
                </template>
                <template #cell(unique_id)="row">
                  <div class="col-sm-12">
                    <div class="media">
                      <img
                        :src="
                          'https://m-p16.akamaized.net/obj/' +
                          row.item.avatar_uri
                        "
                        class="mr-2 rounded-circle avatar-xs"
                        alt="user-pic"
                      />
                      <div class="media-body">
                        <a
                          :href="
                            'https://www.tiktok.com/@' +
                            row.item.unique_id +
                            '/'
                          "
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ row.item.unique_id }}</a
                        >
                        <!-- <p class="text-secondary">{{ $t('all.updated') }}: {{row.item.updated_at}} </p>  -->
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-sm-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <h5>Last 20 {{ $t("instagram.followers") }}</h5>
              </div>
              <div class="col-sm-8 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="followers_created_at"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(followers_created_at) }}</span
                >
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="getFollowersIGRapid"
                >
                  <span v-if="loadingfollowers"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingfollowers"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>

            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingfollowers">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingfollowers && !tableDataFollowers[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0 mt-3"
              v-if="!loadingfollowers && tableDataFollowers[0]"
            >
              <b-table
                :items="tableDataFollowers"
                :fields="fieldsFollowers"
                bordered
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filterFollowers"
              >
                <template #cell(unique_id)="row">
                  <div class="col-sm-12">
                    <div class="media">
                      <img
                        :src="
                          'https://m-p16.akamaized.net/obj/' +
                          row.item.avatar_uri
                        "
                        class="mr-2 rounded-circle avatar-xs"
                        alt="user-pic"
                      />
                      <div class="media-body">
                        <a
                          :href="
                            'https://www.tiktok.com/@' +
                            row.item.unique_id +
                            '/'
                          "
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ row.item.unique_id }}</a
                        >
                        <!-- <p class="text-secondary">{{ $t('all.updated') }}: {{row.item.updated_at}} </p>  -->
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import VueWordCloud from "vuewordcloud";
import TiktokService from "@/helpers/tiktok.service";
import PreferenceService from "@/helpers/preference.service.js";
import SosmedService from "@/helpers/socmed.service";
import moment from "moment";
import SocmedService from "@/helpers/socmed.service";
import axios from "axios";
import { gmapApi } from "vue2-google-maps";
import { ref } from "vue";

/**
 * Profile component
 */
export default {
  page: {
    title: "Tiktok View",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VueWordCloud },
  data() {
    let sentimenOptions = {
      series: [],
    };

    let sourceOptions = {
      series: [],
    };

    return {
      backUrl: "/tiktok",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "tiktok",
          href: "/tiktok",
        },
        {
          text: this.$t("tiktok.tiktok-view"),
          active: true,
        },
      ],
      pref_followers: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_following: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_userpost: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_userinfo: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      id: this.$route.params.id,
      theme: localStorage.getItem("theme"),
      following_created_at: "",
      followers_created_at: "",
      loading_update: false,
      cek_heatmap: false,
      loadingupdate: false,
      loadingsentiment: false,
      loadingsource: false,
      loadingtopmention: false,
      loadingheatmap: false,
      loadingtopfollowing: false,
      loadingtopfollowers: false,
      loadingtimeline: false,
      loadingworldcloud: false,
      loadinghastag: false,
      loadingfollowing: [],
      loadingfollowers: [],
      colors_sentiment: [],
      sentimenOptions,
      sourceOptions,
      title: this.$t("tiktok.tiktok-view"),
      created_at_timeline: "",
      created_at_topmention: "",
      created_at_heatmap: "",
      created_at_wordcloud: "",
      created_at_hastagcloud: "",
      created_at_sentiment: "",
      created_at_source: "",
      elastic: "",
      tophastag: [],
      wordcloud: [],
      source: [],
      heatmap: [],
      sentiment: [],
      timeline: [],
      tableData: [],
      topFollowing: [],
      topFollowers: [],
      tableDataFollowing: [],
      tableDataFollowers: [],
      topMention: [],
      tableDataTopHastag: [],
      tableDataTopWordCloud: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filterFollowers: null,
      filterFollowing: null,
      sortBy: "age",
      sortDesc: false,
      basicInfo: {
        id_tiktokd: "",
        user_id: "",
        video_count: "",
        bio: "",
        sec_id: "",
        followers: "",
        following: "",
        keterangan: "",
        likes: "",
        favorites: "",
        account: "",
        full_name: "",
        is_private: "",
        is_verified: "",
        picture: "",
        avatar: "",
        updated_at: "",
        pin: "",
      },
      fieldsTimeline: [
        { key: "id", thClass: "d-none", tdClass: "d-none" },
        { key: "link", thClass: "d-none", tdClass: "d-none" },
        {
          key: "create_time",
          sortable: true,
          thStyle: { width: "10%" },
          label: this.$t("twitter.table.date"),
        },
        {
          key: "cover",
          sortable: true,
          label: this.$t("tiktok.cover"),
          class: "text-center",
          thStyle: { width: "8%" },
        },
        { key: "desc", sortable: true, label: this.$t("tiktok.caption") },
        {
          key: "play_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "10%" },
          label: this.$t("tiktok.play"),
        },
        {
          key: "digg_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "10%" },
          label: this.$t("tiktok.likes"),
        },
        {
          key: "comment_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "10%" },
          label: this.$t("tiktok.comment_count"),
        },
        {
          key: "share_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "10%" },
          label: this.$t("tiktok.share_count"),
        },
        {
          key: "download_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "10%" },
          label: this.$t("tiktok.download_count"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("twitter.table.action"),
          thStyle: { width: "5%" },
        },
      ],

      fieldsFollowing: [
        { key: "uid", thClass: "d-none", tdClass: "d-none" },
        {
          key: "unique_id",
          sortable: true,
          thStyle: { width: "45%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "nickname",
          sortable: true,
          label: this.$t("instagram.full_name"),
        },
        // { key: "is_private", class: 'text-center', sortable: true, thStyle:{width: '20%'}, label: this.$t('instagram.is_private') },
        { key: "profile_pic_url", thClass: "d-none", tdClass: "d-none" },
      ],

      fieldsFollowers: [
        { key: "uid", thClass: "d-none", tdClass: "d-none" },
        {
          key: "unique_id",
          sortable: true,
          thStyle: { width: "45%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "nickname",
          sortable: true,
          label: this.$t("instagram.full_name"),
        },
        // { key: "is_private", class: 'text-center', sortable: true, thStyle:{width: '20%'}, label: this.$t('instagram.is_private') },
        { key: "profile_pic_url", thClass: "d-none", tdClass: "d-none" },
      ],

      location_coor: [],
      geocoder: null,
      center: { lat: parseFloat(-6.2), lng: parseFloat(106.816666) },
      zoom: 5,
      openedMarkerID: null,
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    google: gmapApi,
  },
  methods: {
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          this.getUserTimeline();
          // this.getTopFollowers();
        })
        .catch((err) => {
          // console.log(err);
        });
    },

    getPreferencesRapidFollowing() {
      let id = 93;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_following = response.data.data;
          this.pref_following.api_host = response.data.data.api_host;
          this.pref_following.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_following.x_rapidapi_key =
            response.data.data.api_header_key;
          this.getFollowing();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesRapidFollowers() {
      let id = 92;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_following = response.data.data;
          this.pref_followers.api_host = response.data.data.api_host;
          this.pref_followers.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_followers.x_rapidapi_key =
            response.data.data.api_header_key;
          this.getFollowers();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getUserBasicInfo() {
      SosmedService.detailTiktok(this.id)
        .then((response) => {
          this.basicInfo.id_tiktok = response.data.data.id_tiktok;
          this.basicInfo.user_id = response.data.data.user_id;
          this.basicInfo.video_count = response.data.data.video_count;
          this.basicInfo.bio = response.data.data.bio;
          this.basicInfo.sec_id = response.data.data.sec_id;
          this.basicInfo.followers = response.data.data.followers;
          this.basicInfo.following = response.data.data.following;
          this.basicInfo.keterangan = response.data.data.keterangan;
          this.basicInfo.likes = response.data.data.likes;
          this.basicInfo.favorites = response.data.data.favorites;
          this.basicInfo.account = response.data.data.account;
          this.basicInfo.full_name = response.data.data.full_name;
          this.basicInfo.is_private = response.data.data.is_private;
          this.basicInfo.is_verified = response.data.data.is_verified;
          this.basicInfo.picture = response.data.data.picture;
          this.basicInfo.updated_at = response.data.data.updated_at;
          this.basicInfo.pin = response.data.data.pin;
        })
        .catch((err) => {
          // console.log('basic err ->',err);
        });
    },

    getPreferencesRapidUserPost() {
      let id = 90;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref = response.data.data;
          this.pref_userpost.api_host = response.data.data.api_host;
          this.pref_userpost.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userpost.x_rapidapi_key = response.data.data.api_header_key;
          // this.getTimelineInstaRapid();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesUserInfo() {
      let id = 80;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_userinfo = response.data.data;
          this.pref_userinfo.api_host = response.data.data.api_host;
          this.pref_userinfo.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userinfo.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // getPreferencesRapidUserPost2() {
    //   let id = 51;
    //   PreferenceService.getRapidApiByID(id)
    //     .then((response) => {
    //       // console.log(response.data.data);
    //       // this.pref = response.data.data;
    //       this.pref_userpost2.api_host = response.data.data.api_host;
    //       this.pref_userpost2.x_rapidapi_host =
    //         response.data.data.api_header_host;
    //       this.pref_userpost2.x_rapidapi_key =
    //         response.data.data.api_header_key;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },

    // timeline
    getUserTimeline() {
      // console.log("get elastic");
      this.loadingtimeline = true;
      TiktokService.getTimelineElastic(this.elastic, this.id)
        .then((response) => {
          // console.log("res", response);
          //   response.data._source.timeline.forEach((element, idx) => {
          //     if (idx == 5) {
          //       const pl = { pl: { full_name: "Yogyakarta" } };
          //       this.tableData.push({ ...element, ...pl });
          //     } else if (idx == 6) {
          //       const pl = { pl: { full_name: "Jakarta" } };
          //       this.tableData.push({ ...element, ...pl });
          //     } else {
          //       this.tableData.push(element);
          //     }
          //   });
          this.tableData = response.data._source.timeline;
          this.created_at_timeline = response.data._source.created_at;
          this.loadingtimeline = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.getTimelineInstaRapid();
          } else {
            // console.log(err);
            this.loadingtimeline = false;
          }
        })
        .finally(() => {
          // this.geocodedAddress();
        });
    },
    getTimelineInstaRapid() {
      console.log("rapid timeline on");
      this.loadingtimeline = true;
      this.loadingupdatetimeline = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userpost.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userpost.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_userpost.api_host + "?user_id=" + this.id + "&count=50",
          { headers: headers }
        )
        .then((response) => {
          this.tableData = [];
          const rapid_data = response.data.aweme_list;
          console.log("rdd", rapid_data);
          // console.log(response.data);
          rapid_data.forEach((val) => {
            const data_rapid = {
              user_id: val.author_user_id,
              aweme_id: val.aweme_id,
              share_url: val.share_url,
              desc: val.desc,
              create_time: this.formatTimestap(val.create_time),
              collect_count: val.statistics.collect_count,
              comment_count: val.statistics.comment_count,
              digg_count: val.statistics.digg_count,
              download_count: val.statistics.download_count,
              play_count: val.statistics.play_count,
              share_count: val.statistics.share_count,
              cover: val.video.ai_dynamic_cover.uri,
            };
            console.log("dr", data_rapid);
            this.tableData.push(data_rapid);
          });

          this.loadingupdatetimeline = false;
          this.loadingtimeline = false;
          this.createTimeline();
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          // this.getTimelineInstaRapid2();
          // this.loadingtimeline = false;
          this.loadingupdatetimeline = false;
        });
    },
    createTimeline() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        timeline: this.tableData,
      };
      // console.log(data);
      TiktokService.createTimelineElastic(this.elastic, this.id, data)
        .then((response) => {
          this.getHeatMapInsta();
          this.timeline_created_at = time;
          this.loadingtimeline = false;
        })
        .catch((err) => {
          console.log("timeline err ->", err);
          this.loadingtimeline = false;
        });
    },

    //userinfo
    searchUserinfo(account) {
      this.loading_update = true;
      var iduser = account;
      this.error = "";
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userinfo.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userinfo.x_rapidapi_key,
      };
      // console.log(headers);
      return axios
        .get(this.pref_userinfo.api_host + "?username=" + iduser, {
          headers: headers,
        })
        .then((response) => {
          let val = response.data.userInfo;
          // console.log("data userinfo", val);
          let data = {
            video_count: val.stats.videoCount,
            followers: val.stats.followerCount,
            following: val.stats.followingCount,
            likes: val.stats.heart,
            user_id: val.user.id,
            sec_id: val.user.secUid,
            is_verified: val.user.verified == true ? "1" : "0",
            is_private: val.user.privateAccount == true ? "1" : "0",
            keterangan: "",
            account: val.user.uniqueId,
            full_name: val.user.nickname,
            bio: val.user.signature,
            picture: val.user.avatarThumb,
          };

          this.saveTiktok(data);
          console.log("data save", data);
          // this.loading_update = false;
          this.result = true;
        })
        .catch((err) => {
          console.log(err);
          this.loading_update = false;
        });
    },

    saveTiktok(data) {
      // console.log(data);
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      var data_tt = {
        video_count: data.video_count,
        followers: data.followers,
        following: data.following,
        likes: data.likes,
        user_id: data.user_id,
        sec_id: data.sec_id,
        is_verified: data.is_verified,
        is_private: data.is_private,
        keterangan: data.keterangan,
        account: data.account,
        full_name: data.full_name,
        bio: data.bio,
        picture: data.picture,
        pin: 0,
      };
      console.log(this.id, data_tt);
      SocmedService.updateTiktok(this.id, data_tt)
        .then((response) => {
          this.loading_update = false;
          this.dnf = false;
          this.searchResult = 0;
          this.result = false;
          this.getUserBasicInfo();
        })
        .catch((err) => {
          console.log(err);
          this.loading_update = false;
        });
    },

    // get last following
    getFollowing() {
      (this.loadingfollowing = true),
        TiktokService.getFollowingElastic(this.elastic, this.id)
          .then((response) => {
            this.following_created_at = response.data._source.created_at;
            this.tableDataFollowing = response.data._source.following;
            this.loadingfollowing = false;
          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 404") {
              this.getFollowingIGRapid();
            } else {
              // console.log(err);
              this.loadingtimeline = false;
            }
          });
    },

    getFollowingIGRapid() {
      // console.log('rapid following on');
      this.loadingfollowing = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_following.x_rapidapi_host,
        "x-rapidapi-key": this.pref_following.x_rapidapi_key,
      };
      // console.log("headers", headers);
      return axios
        .get(this.pref_following.api_host + "?user_id=" + this.id, {
          headers: headers,
        })
        .then((response) => {
          this.tableDataFollowing = [];
          let rapid_data = response.data.followings;
          // console.log("berhasil", response.data.followings);
          rapid_data.forEach((val) => {
            const data = {
              uid: val.uid,
              unique_id: val.unique_id,
              nickname: val.nickname,
              avatar_uri: val.avatar_uri,
              follower_count: val.follower_count,
              following_count: val.following_count,
            };
            // console.log("data", data);
            this.tableDataFollowing.push(data);
            this.loadingfollowing = false;
          });

          if (this.tableDataFollowing[0]) {
            this.createFollowing();
            this.loadingfollowing = false;
          } else {
            this.loadingfollowing = false;
          }
        })
        .catch((err) => {
          console.log("following err ->", err);
        });
    },

    createFollowing() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      this.following_created_at = time;
      const data = {
        created_at: time,
        username: this.id,
        following: this.tableDataFollowing,
      };
      TiktokService.createFollowingElastic(this.elastic, this.id, data)
        .then((response) => {
          this.loadingfollowing = false;
        })
        .catch((err) => {
          console.log("following err ->", err);
          this.loadingfollowing = false;
        });
    },

    // get last followers
    getFollowers() {
      (this.loadingfollowers = true),
        TiktokService.getFollowersElastic(this.elastic, this.id)
          .then((response) => {
            this.followers_created_at = response.data._source.created_at;
            this.tableDataFollowers = response.data._source.followers;
            this.loadingfollowers = false;
          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 404") {
              this.getFollowersIGRapid();
            } else {
              // console.log(err);
              this.loadingtimeline = false;
            }
          });
    },

    getFollowersIGRapid() {
      // console.log('rapid followers on');
      this.loadingfollowers = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_followers.x_rapidapi_host,
        "x-rapidapi-key": this.pref_followers.x_rapidapi_key,
      };
      // console.log("headers", headers);
      return axios
        .get(
          this.pref_followers.api_host + "?user_id=" + this.id + "&count=21",
          {
            headers: headers,
          }
        )
        .then((response) => {
          this.tableDataFollowers = [];
          let rapid_data = response.data.followers;
          // console.log("berhasil", response.data.followers);
          rapid_data.forEach((val) => {
            const data = {
              uid: val.uid,
              unique_id: val.unique_id,
              nickname: val.nickname,
              avatar_uri: val.avatar_uri,
              follower_count: val.follower_count,
              followers_count: val.followers_count,
            };
            // console.log("data", data);
            this.tableDataFollowers.push(data);
            this.loadingfollowers = false;
          });

          if (this.tableDataFollowers[0]) {
            this.createFollowers();
            this.loadingfollowers = false;
          } else {
            this.loadingfollowers = false;
          }
        })
        .catch((err) => {
          console.log("followers err ->", err);
        });
    },

    createFollowers() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      this.followers_created_at = time;
      const data = {
        created_at: time,
        username: this.id,
        followers: this.tableDataFollowers,
      };
      TiktokService.createFollowersElastic(this.elastic, this.id, data)
        .then((response) => {
          this.loadingfollowers = false;
        })
        .catch((err) => {
          console.log("followers err ->", err);
          this.loadingfollowers = false;
        });
    },

    //map
    geocodedAddress() {
      this.$gmapApiPromiseLazy().then(() => {
        if (this.google) {
          this.geocoder = new this.google.maps.Geocoder();
        }
      });
      this.location_coor = [];
      this.tableData.forEach((element) => {
        if (Object.keys(element.place).length !== 0) {
          this.geocoder.geocode(
            { address: element.place.full_name },
            (results, status) => {
              this.location_coor.push({
                lat: results[0].geometry.location.lat(),
                long: results[0].geometry.location.lng(),
                content: element,
              });
            }
          );
        }
      });
    },
    openMarker(id) {
      this.openedMarkerID = id;
    },
    formatDate(value) {
      return moment(value).format("DD MMM YYYY, hh:mm");
    },
    formatDateRefresh(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDay(value) {
      return moment(value).format("dddd");
    },
    formatTimestap(value) {
      return moment.unix(value).format("MM-DD-YYYY");
    },
    toFixed(value) {
      return value.toFixed(0);
    },
  },
  mounted() {
    this.theme = localStorage.getItem("theme");
    this.totalRows = this.items.length;
    this.getPreferencesRapidUserPost();
    this.getPreferencesUserInfo();
    this.getPreferences();
    this.getPreferencesRapidFollowers();
    this.getPreferencesRapidFollowing();
    this.getUserBasicInfo();
    this.$gmapApiPromiseLazy().then(() => {
      if (this.google) {
        this.geocoder = new this.google.maps.Geocoder();
      }
    });
  },
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
.my-custom-scrollbar {
  position: relative;
  height: 500px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>
